import modaal from 'modaal';
import $ from 'jquery';

class MadeThis {
    constructor() {
        this.overlay = null;
        this.madeThisModalOpen = false;
    }

    init() {
        this.bindEvents();
        this.handleModalClose();
        this.handleServingsSelector();
        this.lines();
    }

    bindEvents() {
        let modal = $('.made-this-modal').html();
        if (modal != null) {
            $('.made-this-btn').modaal({
                content_source: '#made-this-modal',
                overlay_opacity: 0.6,
                // width: 707,
                hide_close: true,
                custom_class: 'made-this-modal-container',
                after_open: () => { this.madeThisModalOpen = true; },
                after_close: () => { this.madeThisModalOpen = false;  $('.made-this-btn-container').addClass('made-this-btn-selected'); }
            });

            $('.modal-close').on('click', () => {
                $('.made-this-btn').modaal('close');
            });            
        }

        let videoModal = $('.supplemental-video-modal').html();
        if (videoModal != null) {
            $('.image-container').modaal({
                content_source: '#supplemental-video-modal',
                overlay_opacity: 0.6,
                width: 707,
                height: 261,
                custom_class: 'supplemental-video-container',
            });

            $('.modal-close').on('click', () => {
                $('.image-container').modaal('close');
            });
        }

        let servings = $('#servings-select').val();
        $('.checkbox-wrapper').hide();
        $(`.checkbox-wrapper[data-servings="${servings}"]`).show();

        $('#servings-select').change(() => {
            let servings = $('#servings-select').val();
            $('.checkbox-wrapper').hide();
            $(`.checkbox-wrapper[data-servings="${servings}"]`).show();
        });
    } 

    handleModalClose() {
        $(document).on('click', (e) => {
            if ($(e.target).hasClass('modaal-outer-wrapper')) {
                if (this.madeThisModalOpen) {
                    $('.made-this-btn').modaal('close');
                }
                $('.image-container').modaal('close');
            }
        });
    }

    handleServingsSelector() {
        $('#servings-select').on('click', (e) => {
            const parent = $(e.target).parent();
            if (!parent.hasClass('open')) {
                parent.addClass('open');
                return;
            }
            parent.removeClass('open');
        });
    }

    lines() {
        $('.recipe-detail-instructions-ordered-list li:not(:last-child)').append('<hr class="directions-separator">');
    }
}

export default MadeThis;

$(() => {
    const madeThis = new MadeThis();
    madeThis.init();
});
